import { render } from "./basenumber.vue?vue&type=template&id=7336578f&scoped=true"
import script from "./basenumber.vue?vue&type=script&lang=js"
export * from "./basenumber.vue?vue&type=script&lang=js"

import "./basenumber.vue?vue&type=style&index=0&id=7336578f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7336578f"]])

export default __exports__